import React, { Component } from "react";
import "../App.css";
import "./HomeComponent.css";
import { Link } from "react-router-dom";

class Home extends Component {
  render() {
    return (
      <div className="home-page">
        {/* HERO SECTION */}
        <div className="hero-section">
          <div className="hero-badge">
            <span className="hero-badge-dot"></span>
            Blockchain-Powered Land Registry
          </div>
          <h1 className="hero-title">
            Secure Land Records<br />
            on the <span>Blockchain</span>
          </h1>
          <p className="hero-subtitle">
            Odisha's Digital Land Record Management System — transparent,
            tamper-proof, and accessible. Powered by Ethereum smart contracts
            and decentralized storage.
          </p>
          <div className="hero-actions">
            <Link to="/allplots" className="btn-hero-primary">
              <i className="fa fa-map"></i>
              Browse All Plots
            </Link>
            <Link to="/signup" className="btn-hero-secondary">
              <i className="fa fa-user-plus"></i>
              Register / Login
            </Link>
          </div>
        </div>

        {/* STATS SECTION */}
        <div className="stats-section">
          <div className="stats-section-title">Odisha Land Statistics</div>
          <div className="stats-section-sub">Real-time data from the state land registry</div>
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-card-icon">
                <i className="fa fa-map-marker"></i>
              </div>
              <div className="stat-card-value">30</div>
              <div className="stat-card-label">Districts</div>
            </div>
            <div className="stat-card">
              <div className="stat-card-icon">
                <i className="fa fa-building"></i>
              </div>
              <div className="stat-card-value">317</div>
              <div className="stat-card-label">Tahasil Offices</div>
            </div>
            <div className="stat-card">
              <div className="stat-card-icon">
                <i className="fa fa-circle-o"></i>
              </div>
              <div className="stat-card-value">2,410</div>
              <div className="stat-card-label">RI Circles</div>
            </div>
            <div className="stat-card">
              <div className="stat-card-icon">
                <i className="fa fa-home"></i>
              </div>
              <div className="stat-card-value">51,701</div>
              <div className="stat-card-label">Villages</div>
            </div>
            <div className="stat-card">
              <div className="stat-card-icon">
                <i className="fa fa-file-text"></i>
              </div>
              <div className="stat-card-value">1.70 Cr</div>
              <div className="stat-card-label">Khatiyans</div>
            </div>
            <div className="stat-card">
              <div className="stat-card-icon">
                <i className="fa fa-th-large"></i>
              </div>
              <div className="stat-card-value">5.70 Cr</div>
              <div className="stat-card-label">Total Plots</div>
            </div>
            <div className="stat-card">
              <div className="stat-card-icon">
                <i className="fa fa-users"></i>
              </div>
              <div className="stat-card-value">3.58 Cr</div>
              <div className="stat-card-label">Registered Tenants</div>
            </div>
          </div>
        </div>

        {/* FEATURES SECTION */}
        <div className="features-section">
          <div className="stats-section-title">Why LandChain?</div>
          <div className="stats-section-sub">Modern land governance built on trust and technology</div>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon feature-icon-blue">
                <i className="fa fa-shield"></i>
              </div>
              <div className="feature-title">Immutable Records</div>
              <p className="feature-desc">Every transaction is recorded on the Ethereum blockchain — permanent, transparent and tamper-proof.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon feature-icon-green">
                <i className="fa fa-bolt"></i>
              </div>
              <div className="feature-title">Instant Verification</div>
              <p className="feature-desc">Verify land ownership, transaction history and title clarity instantly without visiting any office.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon feature-icon-purple">
                <i className="fa fa-cloud-upload"></i>
              </div>
              <div className="feature-title">IPFS Document Storage</div>
              <p className="feature-desc">All plot documents and images are stored on IPFS — decentralized, censorship-resistant storage.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon feature-icon-orange">
                <i className="fa fa-handshake-o"></i>
              </div>
              <div className="feature-title">Smart Contracts</div>
              <p className="feature-desc">Land transfers, sales, and divisions are governed by auditable, self-executing smart contracts.</p>
            </div>
          </div>
        </div>

        {/* DEPT LOGIN */}
        <div className="info-section">
          <div className="dept-login-card">
            <h5 style={{color: '#064E3B', fontWeight: 700, marginBottom: 8}}>Department of Science &amp; Technology</h5>
            <p style={{color: '#6B7A99', fontSize: '0.88rem', marginBottom: 20}}>Government of Odisha — Official Land Registry Portal</p>
            <Link to="/signup" className="dept-login-btn">
              <i className="fa fa-sign-in"></i>
              Department User Login
            </Link>
          </div>
          <div className="info-card">
            <p>
              The Odisha Land Records Management System leverages blockchain technology to ensure
              complete transparency and prevent land fraud. All records are stored on a public
              ledger with cryptographic proof of ownership.
            </p>
            <hr />
            <p style={{marginBottom: 0}}>
              Citizens can view land records, verify ownership history, and conduct plot transfers
              entirely online. The system integrates with MetaMask for secure digital signatures
              and maintains a complete audit trail of every transaction.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;
